export { default as DocumentTextSolidIcon } from './DocumentTextSolidIcon';
